// ======================================================================
// File Name       : ScoringReportModalDialogContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import React, { Component } from 'react';
import { Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { change, getFormValues, isInvalid, isPristine, reduxForm } from 'redux-form';
import { getS3SignedUrl } from '../../../actions/AuthAction';
import * as scoringReportAction from '../../../actions/ScoringReportAction';
import DialogConfirm from '../../../components/DialogConfirm';
import InformationDialog from '../../../components/InformationDialog';
import InputConfirmDialog from '../../../components/InputConfirmDialog';
import InputInformationDialog from '../../../components/InputInformationDialog';
import ModalWrapper from '../../../components/modal/ModalWrapper';
import ScoringReportModalHeader from '../../../components/report/scoring/ScoringReportModalHeader';
import ScoringReportModalQuestion from '../../../components/report/scoring/ScoringReportModalQuestion';
import { MANAGEMENT_AUTHORITY_TYPE } from '../../../constants/AuthorityConstant';
import {
  MAX_IFRAME_QUESTION_COL, MAX_SCORING_COL,
  MIN_IFRAME_QUESTION_COL, MIN_SCORING_COL, REPORT_SCRIPT_S3_PATH, SUPER_USER_SECERN_ID
} from '../../../constants/index';
import * as MessageTemplate from '../../../constants/MessageTemplate';
import { S3_SCRIPT_CLASS_NAME } from '../../../constants/S3Constants';
import * as ReportConstants from '../../../constants/ScoringReportConstants';
import ZoomIn from '../../../images/zoom_in.png';
import ZoomOut from '../../../images/zoom_out.png';
import { isSuperUser } from '../../../utils/index';
import { checkAuthorSuperuser } from '../../../utils/PageUtils';

class ReportModalDialogContainer extends Component {
  constructor() {
    super();
    this.state = {
      showModalConfirm: false,
      showInformationModal: false,
      showInputConfirmModal: false,
      showInputInformationModal: false,
      typeModalConfirm: null,

      enableApprovalButton: false,
      enableRemandButton: false,
      enableCollectButton: false,

      enableCorrectButton: false,
      enableWithdrawalButton: false,
      enableReasonButton: false,
      enableFinishSaveButton: false,
      enableSaveButton: false,
      editMode: false,

      enableBackPageButton: false,
      enableNextPageButton: false,
      page: 0,
      reportCommentList: [],
      detailDrillList: [],
      forceRender: false,
      reportComment: '',
      denialReason: '',
      iframeQuestionCol: 7,
      scoringCol: 5,
      isShowDetail: true,
      isCallDrillTopInfo: true, // #7404
    };

    this.onConfirmDialogCancelBtnClick = this.onConfirmDialogCancelBtnClick.bind(this);
    this.onConfirmDialogOkBtnClick = this.onConfirmDialogOkBtnClick.bind(this);
    this.onInputConfirmDialogOkBtnClick = this.onInputConfirmDialogOkBtnClick.bind(this);
    this.handleOpenInputDialog = this.handleOpenInputDialog.bind(this);
    this.handleBackPageBtn = this.handleBackPageBtn.bind(this);
    this.handleNextPageBtn = this.handleNextPageBtn.bind(this);
    this.handleHideModal = this.handleHideModal.bind(this);
    this.zoomContent = this.zoomContent.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { detailDrill, modalReport, authedUser, drillSecernId } = nextProps;
    const {
      checkerUserSecernId,
      reportStatus,
    } = modalReport;
    const { userInfo, managementFunctionAuthorityInfo } = authedUser;
    const { userSecernId, representationUserSecernId } = userInfo;
    const { scoringManagementAuthority } = managementFunctionAuthorityInfo;
    this.setupButtonList(reportStatus,
      checkerUserSecernId,
      userSecernId,
      scoringManagementAuthority,
      representationUserSecernId, // Step 11.0.0
    );
    this.setState({
      detailDrill,
      drillSecernId, // #7404
    });

    // #7404 START
    const { isCallDrillTopInfo } = this.state;
    if (drillSecernId && isCallDrillTopInfo) {
      const drillTopInfoParam = {
        drillSecernId,
      }
      this.props.dispatch(scoringReportAction.getDrillTopInfo(drillTopInfoParam));
      this.setState({
        isCallDrillTopInfo: false,
      });
    }
    // #7404 END
  }

  componentDidMount() {
    this.initData();
  }

  componentWillUnmount() {
    const { detailDrill } = this.props;
    if (detailDrill && detailDrill.enforceHistoryUrl) {
      this.props.dispatch(scoringReportAction.resetDrillDetail());
    }
    // #7232 START
    this.removeCustomScript();
    // #7232 END
  }

  initData() {
    const {
      itemLearningHistoryReportIdAuto,
      itemLearningHistoryIdAuto,
      drillHistoryInfo,
    } = this.props.modalReport;
    const { questionSecernIdList } = drillHistoryInfo;
    // #7232 START
    const { institutionId } = this.props.authedUser;
    // #7232 END
    if (questionSecernIdList.length !== 0) {
      if (questionSecernIdList.length !== 1) {
        this.setState({ enableNextPageButton: true });
      }
      const questionSecernId = questionSecernIdList[0];
      this.props.dispatch(
        scoringReportAction.getDetailDrill(
          itemLearningHistoryIdAuto,
          itemLearningHistoryReportIdAuto,
          questionSecernId,
        ),
      ).then(() => {
        // #7404 START
        const eachQuestionParam = {
          drillSecernId: this.state.drillSecernId,
          questionListInput: [
            {
              questionSecernId,
            },
          ],
        };
        this.props.dispatch(scoringReportAction.getEachQuestion(eachQuestionParam));
        // #7404 END
      });
      // #7232 START
      // #7287 START
      const params = {
        s3FilePath: REPORT_SCRIPT_S3_PATH.replace(':institutionId', institutionId),
        scriptClassName: S3_SCRIPT_CLASS_NAME.REPORT_SCRIPT,
      };
      this.props.dispatch(getS3SignedUrl(params));
      // #7287 END
      // #7232 END
    }
  }

  removeCustomScript() {
    $(`.${S3_SCRIPT_CLASS_NAME.REPORT_SCRIPT}`).remove();
  }
  // #7232 END

  getModalOptions() {
    const { enableBackPageButton, enableNextPageButton } = this.state;
    let { reportStatus } = this.props.modalReport;
    reportStatus = parseInt(reportStatus, 10);
    let titleName = null;
    if (reportStatus === ReportConstants.REPORT_STATUS_ID.CHECKING) {
      titleName = `【${ReportConstants.REPORT_STATUS_NAME.CHECKING}】`;
    } else if (reportStatus === ReportConstants.REPORT_STATUS_ID.REMAND) {
      titleName = `【${ReportConstants.REPORT_STATUS_NAME.REMAND}】`;
    } else if (reportStatus === ReportConstants.REPORT_STATUS_ID.PENDING_APPROVAL) {
      titleName = `【${ReportConstants.REPORT_STATUS_NAME.PENDING_APPROVAL}】`;
    } else if (reportStatus === ReportConstants.REPORT_STATUS_ID.APPPROVED) {
      titleName = `【${ReportConstants.REPORT_STATUS_NAME.APPPROVED}】`;
    } else if (reportStatus === ReportConstants.REPORT_STATUS_ID.RESULT_RETURN) {
      titleName = `【${ReportConstants.REPORT_STATUS_NAME.RESULT_RETURN}】`;
    }
    return {
      title: titleName,
      footerBtns: [
        { name: '一覧へ戻る',
          onClick: this.handleHideModal,
          className: 'position-absolute start-0 margin-left-20',
          variant: 'default',
        },
        {
          name: '前へ',
          onClick: this.handleBackPageBtn,
          variant: 'primary',
          disabled: !enableBackPageButton,
        },
        {
          name: '次へ',
          onClick: this.handleNextPageBtn,
          variant: 'primary',
          disabled: !enableNextPageButton,
        },
      ],
      dialogClassName: 'scoring-report-dialog',
    };
  }

  handleHideModal() {
    this.content = MessageTemplate.MSG_CONFIRM_BACK_PAGE;
    this.mdSize = null;
    this.setState({ showModalConfirm: true, typeModalConfirm: null });
  }

  handleBackPageBtn() {
    // #7461 START
    const { pristine, invalid } = this.props;
    if (!pristine && invalid) return;
    // #7461 END
    let { page, enableBackPageButton } = this.state;
    this.saveDrillDetailToState(page);
    page -= 1;
    if (page === 0) {
      enableBackPageButton = false;
    } else {
      enableBackPageButton = true;
    }
    const {
      drillHistoryInfo,
    } = this.props.modalReport;
    const { questionSecernIdList } = drillHistoryInfo;
    const questionSecernId = questionSecernIdList[page];
    this.setState(
      {
        page,
        enableBackPageButton,
        enableNextPageButton: true,
      },
      () => {
        this.getDataQuestion(page, questionSecernId);
      },
    );
  }

  getDataQuestion(page, questionSecernId, isReset) {
    const { drillSecernId, detailDrillList } = this.state;
    // #7404 START
    const eachQuestionParam = {
      drillSecernId,
      questionListInput: [
        {
          questionSecernId,
        },
      ],
    };
    this.props.dispatch(scoringReportAction.getEachQuestion(eachQuestionParam));
    // #7404 END

    if (detailDrillList && detailDrillList[page]) {
      const detailDrill = detailDrillList[page];
      this.props.dispatch(scoringReportAction.setExistedDetailDrill(detailDrill));
      if (!isReset) {
        this.props.reset();
      }
    } else {
      const { itemLearningHistoryReportIdAuto, itemLearningHistoryIdAuto } = this.props.modalReport;
      this.props.dispatch(
        scoringReportAction.getDetailDrill(
          itemLearningHistoryIdAuto,
          itemLearningHistoryReportIdAuto,
          questionSecernId,
        ),
      )
      .then(() => {
        this.props.reset();
      });
    }
  }

  saveModalReportData() {
    const { modalReport } = this.props;
    // save report comment and denialReason to modalReport in store
    const { denialReason, reportComment } = this.props.reportModalDialog.values;
    modalReport.denialReason = denialReason;
    modalReport.reportComment = reportComment;
    this.props.dispatch(scoringReportAction.saveModalReport(modalReport));
  }

  saveDrillDetailToState(index, isShowDialog) {
    const { detailDrill, modalReport, reportModalDialog } = this.props;
    const { drillHistoryInfo } = modalReport;
    const { questionSecernIdList } = drillHistoryInfo;
    const { detailDrillList, reportCommentList } = this.state;
    const {
      reportCommentDrillQuestion,
      answerJudgeResult,
      partsQuestionInfo,
      modifiedSankakuPoint,
      point, // #7404
    } = reportModalDialog.values;
    // if answerJudgeResult = null, get question detail error
    if (answerJudgeResult === null) {
      return;
    }
    // handle for big question
    if (parseInt(answerJudgeResult, 10) === ReportConstants.ANSWER_JUDGE_RESULT.BIG_QUESTION) {
      const subQuestionList = [];
      const { subQuestionArray } = partsQuestionInfo;
      for (let i = 0; i < subQuestionArray.length; i++) {
        const subQuestionItem = {
          subQuestionSecernId: subQuestionArray[i].subQuestionSecernId,
          subAnswerJudgeResult: reportModalDialog.values[`subAnswerJudgeResult_${i}`],
          subModifiedSankakuPoint: parseInt(reportModalDialog.values[`subModifiedSankakuPoint_${i}`], 10), // #7404
          subPoint: subQuestionArray[i].subPoint, // #7404
        };
        subQuestionList.push(subQuestionItem);
      }
      const partsQuestionInfoList = {
        subQuestionArray: subQuestionList,
      };
      reportCommentList[index] = {
        partsQuestionInfo: partsQuestionInfoList,
        questionSecernId: questionSecernIdList[index],
        reportCommentDrillQuestion,
        questionInfo: { answerJudgeResult: ReportConstants.ANSWER_JUDGE_RESULT.BIG_QUESTION },
      };
    } else {
      // handle for single question
      reportCommentList[index] = {
        questionSecernId: questionSecernIdList[index],
        reportCommentDrillQuestion,
        questionInfo: {
          answerJudgeResult,
          modifiedSankakuPoint: parseInt(modifiedSankakuPoint, 10), // #7404
          point, // #7404
        },
        partsQuestionInfo: null,
      };
    }
    // save reportCommentList to drill detail
    if (reportCommentList[index].partsQuestionInfo) {
      detailDrill.partsQuestionInfo = reportCommentList[index].partsQuestionInfo;
    } else {
      detailDrill.questionInfo = reportCommentList[index].questionInfo;
    }
    detailDrill.questionSecernId = reportCommentList[index].questionSecernId || '';
    detailDrill.reportCommentDrillQuestion = reportCommentList[index].reportCommentDrillQuestion || '';
    detailDrillList[index] = detailDrill;

    this.setState({ reportCommentList, detailDrillList },
      () => {
        // show dialog confirm, dont need to save and clear info
        if (!isShowDialog) {
          // save report comment and denialReason to modalReport in store before initial new form
          this.saveModalReportData();
          this.clearQuestionInform();
        }
      },
    );
  }

  clearQuestionInform() {
    this.props.change('partsQuestionInfo', null);
    this.props.change('answerJudgeResult', null);
    this.props.change('reportCommentDrillQuestion', null);
  }

  handleNextPageBtn() {
    // #7461 START
    const { pristine, invalid } = this.props;
    if (!pristine && invalid) return;
    // #7461 END
    const {
      drillHistoryInfo,
    } = this.props.modalReport;
    const { questionSecernIdList } = drillHistoryInfo;
    let { page, enableNextPageButton } = this.state;
    this.saveDrillDetailToState(page);
    page += 1;
    if (page === questionSecernIdList.length - 1) {
      enableNextPageButton = false;
    } else {
      enableNextPageButton = true;
    }
    const questionSecernId = questionSecernIdList[page];
    this.setState(
      {
        page,
        enableNextPageButton,
        enableBackPageButton: true,
      },
      () => {
        this.getDataQuestion(page, questionSecernId);
      },
    );
  }

  handleOpenInformationDialog(mdContent, type) {
    this.content = mdContent;
    this.setState({ showInformationModal: true, typeModalConfirm: type });
  }

  handleOpenInputDialog(mdContent, name, value, type, disableInput) {
    this.content = mdContent;
    this.name = name;
    this.value = value;
    let { showInputInformationModal, showInputConfirmModal } = this.state;
    if (type === ReportConstants.Label_Reason) {
      showInputInformationModal = true;
    } else {
      this.disableInput = disableInput;
      showInputConfirmModal = true;
    }
    this.setState({
      showInputInformationModal,
      showInputConfirmModal,
      typeModalConfirm: type,
    });
  }

  onInputConfirmDialogOkBtnClick() {
    const { denialReason } = this.props.reportModalDialog.values;
    let { itemLearningHistoryReportIdAuto } = this.props.reportModalDialog.values;
    if (!itemLearningHistoryReportIdAuto) {
      itemLearningHistoryReportIdAuto = this.props.modalReport.itemLearningHistoryReportIdAuto;
    }
    const { checkerUserSecernId, itemLearningHistoryIdAuto } = this.props.modalReport;
    if (this.disableInput === false) {
      this.handleOpenInputDialog(
        MessageTemplate.MSG_REMAND_CONFIRM_REPORT,
        ReportConstants.Name_Denial_Reason,
        denialReason,
        ReportConstants.Label_Remand,
        true,
      );
    } else {
      let { enableRemandButton } = this.state;
      const param = {
        reportOperationType: ReportConstants.REPORT_OPERATION_TYPE.REMAND,
        reportListAuthorize: [
          {
            itemLearningHistoryReportIdAuto,
            checkerUserSecernId,
            denialReason,
          },
        ],
      };
      const self = this.props;
      this.props.dispatch(scoringReportAction.editByCorrector(param)).then(() => {
        self.hideModal();
        self.onCloseScoringReportDialog();
      });
      enableRemandButton = true;
      this.setState({
        enableRemandButton,
      });
      this.onConfirmDialogCancelBtnClick();
    }
  }

  handleOpenConfirmDialog(mdContent, mdSize, type) {
    // #7461 START
    const { pristine, invalid } = this.props;
    if (!pristine && invalid) return;
    // #7461 END
    this.content = mdContent;
    this.mdSize = mdSize;
    const { page } = this.state;
    this.saveDrillDetailToState(page, true);
    this.setState({ showModalConfirm: true, typeModalConfirm: type });
  }

  handleEnableFinishSaveButton(type) {
    // edit mode, enable button Finish and Save
    this.setState({
      typeModalConfirm: type,
      editMode: true,
      enableFinishSaveButton: true,
      enableSaveButton: true,
      enableCorrectButton: false,
    });
  }

  onConfirmDialogCancelBtnClick(shouldReset) {
    if (shouldReset) {
      const { initialValues } = this.props;
      let resetValue = '';
      if (initialValues) {
        resetValue = initialValues.denialReason;
      }
      this.props.dispatch(change('reportModalDialog', 'denialReason', resetValue));
    }
    this.setState({
      showModalConfirm: false,
      showInputConfirmModal: false,
      typeModalConfirm: null,
    });
  }

  onConfirmDialogOkBtnClick() {
    const {
      enableCorrectButton,
      enableReasonButton,
      enableFinishSaveButton,
      enableSaveButton,
      enableCollectButton,
      enableApprovalButton,
      enableRemandButton,
      typeModalConfirm,
      showModalConfirm,
      showInformationModal,
      showInputConfirmModal,
      showInputInformationModal,
      editMode,
      page,
    } = this.state;
    const {
      drillHistoryInfo,
    } = this.props.modalReport;
    const { questionSecernIdList } = drillHistoryInfo;
    const questionSecernId = questionSecernIdList[page];
    const { itemLearningHistoryReportIdAuto, checkerUserSecernId } = this.props.modalReport;
    const { denialReason, reportComment } = this.props.reportModalDialog.values;
    const { reportCommentList } = this.state;
    const { sankakuJudgeUseSet } = this.props; //#7482
    let param = null;
    let commentList = [];
    //Fix #5337, #5338
    if(reportCommentList && reportCommentList.length ){
      reportCommentList.forEach((comment) => {
        if(comment){
          commentList.push(comment);
        }
      });
    }
    switch (typeModalConfirm) {
      case ReportConstants.Label_Approval: // 0
        // handle approve report
        param = {
          reportOperationType: ReportConstants.REPORT_OPERATION_TYPE.APPROVAL,
          reportListAuthorize: [
            {
              checkerUserSecernId,
              itemLearningHistoryReportIdAuto,
            },
          ],
        };
        break;
      case ReportConstants.Label_Remand: // 1
        // handle Remand report
        param = {
          reportOperationType: ReportConstants.REPORT_OPERATION_TYPE.REMAND,
          reportListAuthorize: [
            {
              checkerUserSecernId,
              itemLearningHistoryReportIdAuto,
              denialReason,
            },
          ],
        };
        break;
      case ReportConstants.Label_Collect: // 2
        // handle collect report
        param = {
          reportOperationType: ReportConstants.REPORT_OPERATION_TYPE.COLLECT,
          reportListAuthorize: [
            {
              checkerUserSecernId,
              itemLearningHistoryReportIdAuto,
            },
          ],
        };
        break;
      case ReportConstants.Label_Correct:
        // handle correct report
        break;
      case ReportConstants.Label_WithDrawal:
        // handle WithDrawal report
        param = {
          reportOperationType: ReportConstants.REPORT_OPERATION_TYPE.WITHDRAWAL,
          reportListCheck: [
            {
              itemLearningHistoryReportIdAuto,
              reportCommentDrill: reportComment,
              reportCommentList: commentList,
              sankakuJudgeUseSet, // #7482
            },
          ],
        };
        break;
      case ReportConstants.Label_Finish:
        // handle Finish report
        param = {
          reportOperationType: ReportConstants.REPORT_OPERATION_TYPE.FINISH,
          reportListCheck: [
            {
              itemLearningHistoryReportIdAuto,
              reportCommentDrill: reportComment,
              reportCommentList: commentList,
              sankakuJudgeUseSet, // #7482
            },
          ],
        };
        break;
      case ReportConstants.Label_Save:
        // handle Save report
        param = {
          reportOperationType: ReportConstants.REPORT_OPERATION_TYPE.SAVE,
          reportListCheck: [
            {
              itemLearningHistoryReportIdAuto,
              reportCommentDrill: reportComment,
              reportCommentList: commentList,
              sankakuJudgeUseSet, // #7482
            },
          ],
        };
        break;
      default:
        break;
    }
    if (param) {
      this.props.dispatch(scoringReportAction.editByCorrector(param)).then(() => {
        if (typeModalConfirm == ReportConstants.Label_Save) {
          this.props.dispatch(scoringReportAction.scoringReportSearchInModal(this.props.modalReport)).then(() => {
            this.getDataQuestion(page, questionSecernId, true);
          });
          $("#iframe_wrapper").find("iframe")[0].src = this.props.detailDrill.enforceHistoryUrl;
        } else {
          this.resetState();
          this.props.hideModal();
          this.props.onCloseScoringReportDialog();
        }
      });
    }
    // check dialog have typeModalConfirm is null to close dialog
    if (typeModalConfirm === null) {
      this.props.hideModal();
      this.props.onCloseScoringReportDialog();
    }
    this.setState({
      showModalConfirm: false,
      showInformationModal: false,
      showInputConfirmModal: false,
      showInputInformationModal: false,
      typeModalConfirm: null,
    });
  }

  resetState() {
    this.setState({
      enableCollectButton: false,
      enableCorrectButton: false,
      enableReasonButton: false,
      enableApprovalButton: false,
      enableRemandButton: false,
      enableFinishSaveButton: false,
      enableSaveButton: false,
      showModalConfirm: false,
      showInformationModal: false,
      showInputConfirmModal: false,
      showInputInformationModal: false,
      typeModalConfirm: null,
      editMode: false,
    });
  }

  setupButtonList(reportStatus, checkerUserSecernId, userSecernId, scoringManagementAuthority, representationUserSecernId) {
    let {
      enableApprovalButton,
      enableRemandButton,
      enableCollectButton,

      enableCorrectButton,
      enableWithDrawalButton,
      enableReasonButton,
      enableFinishSaveButton,
      enableSaveButton,
    } = this.state;
    const { editMode } = this.state;
    reportStatus = parseInt(reportStatus, 10);
    switch (reportStatus) {
      case ReportConstants.REPORT_STATUS_ID.CHECKING:
        enableCollectButton = true;
        break;
      case ReportConstants.REPORT_STATUS_ID.REMAND:
        enableCollectButton = true;
        enableReasonButton = true;
        break;
      case ReportConstants.REPORT_STATUS_ID.PENDING_APPROVAL:
        // if have full permission, enable Approval and Remand Button, else Reason button
        if (scoringManagementAuthority === MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT) {
          enableApprovalButton = true;
          enableRemandButton = true;
        } else {
          enableWithDrawalButton = true;
        }
        break;
      case ReportConstants.REPORT_STATUS_ID.APPPROVED:
        enableRemandButton = true;
        break;
      case ReportConstants.REPORT_STATUS_ID.RESULT_RETURN:
        enableRemandButton = true;
        break;
      default:
        break;
    }
    const { authedUser } = this.props;
    let displayUserType = -1;
    if (authedUser && authedUser.userInfo) {
      displayUserType = authedUser.userInfo.displayUserType;
    }
    // check checker is user login, if yes, enable button correct for status CHECKING and REMAND
    // Step 11.0.0 START
    if (
      ((checkerUserSecernId && userSecernId && userSecernId === checkerUserSecernId) ||
        checkAuthorSuperuser(checkerUserSecernId, isSuperUser(displayUserType), representationUserSecernId)) &&
      (reportStatus === ReportConstants.REPORT_STATUS_ID.CHECKING ||
        reportStatus === ReportConstants.REPORT_STATUS_ID.REMAND)
    ) {
      enableCorrectButton = true;
    }
    // Step 11.0.0 END

    // edit mode, enable button Finish and Save
    if (editMode) {
      enableFinishSaveButton = true;
      enableSaveButton = true;
      enableCorrectButton = false;
    }
    this.setState({
      enableApprovalButton,
      enableRemandButton,
      enableCollectButton,

      enableCorrectButton,
      enableWithDrawalButton,
      enableReasonButton,
      enableFinishSaveButton,
      enableSaveButton,
      editMode,
    });
  }

  zoomContent(isZoomIn) {
    const data = { ...this.state };
    const iframeQuestionCol = data.iframeQuestionCol;
    const scoringCol = data.scoringCol;
    if (isZoomIn && scoringCol === MAX_SCORING_COL && iframeQuestionCol === MIN_IFRAME_QUESTION_COL) {
      this.setState({
        ...this.state,
        iframeQuestionCol: MAX_IFRAME_QUESTION_COL,
        scoringCol: MIN_SCORING_COL,
        isShowDetail: false,
      }, () => {
        $('.scoring-report-dialog .iframe-question').attr('style', 'height: 71vh !important; overflow-y: hidden; margin-bottom: 25px');
      });
    }
    if (!isZoomIn && scoringCol === MIN_SCORING_COL && iframeQuestionCol === MAX_IFRAME_QUESTION_COL) {
      this.setState({
        ...this.state,
        iframeQuestionCol: MIN_IFRAME_QUESTION_COL,
        scoringCol: MAX_SCORING_COL,
        isShowDetail: true,
      }, () => {
        $('.scoring-report-dialog .iframe-question').removeAttr('style');
      });
    }
  }

  render() {
    const {
      itemReportIdAuto,
      itemLearningHistoryReportIdAuto,
      reportDeadline,
      reportReturnPlanDate,
      reportName,
      denialReason,
      reportComment,
      checkerUserSecernId,
      reportStatus,
      drillHistoryInfo,
    } = this.props.modalReport;
    const {
      reportCommentDrillQuestion,
      enforceHistoryUrl,
      questionInfo,
      partsQuestionInfo,
    } = this.props.detailDrill;

    const {
      enableApprovalButton,
      enableRemandButton,
      enableCollectButton,

      enableCorrectButton,
      enableWithDrawalButton,
      enableReasonButton,
      enableFinishSaveButton,
      enableSaveButton,
      editMode,
    } = this.state;
    const { managementFunctionAuthorityInfo } = this.props.authedUser;
    const { scoringManagementAuthority } = managementFunctionAuthorityInfo;
    return (
      <div>
        <ModalWrapper {...this.getModalOptions()} hideModal={this.handleHideModal}>
          { this.state.isShowDetail &&
            <ScoringReportModalHeader
              itemReportIdAuto={itemReportIdAuto}
              itemLearningHistoryReportIdAuto={itemLearningHistoryReportIdAuto}
              reportDeadline={reportDeadline}
              reportReturnPlanDate={reportReturnPlanDate}
              reportName={reportName}
              enableApprovalButton={enableApprovalButton}
              enableCollectButton={enableCollectButton}
              enableCorrectButton={enableCorrectButton}
              enableFinishSaveButton={enableFinishSaveButton}
              enableReasonButton={enableReasonButton}
              enableRemandButton={enableRemandButton}
              enableWithDrawalButton={enableWithDrawalButton}
              drillHistoryInfo={drillHistoryInfo}
              enableSaveButton={enableSaveButton}
              scoringManagementAuthority={scoringManagementAuthority}
              reportStatus={reportStatus}
              reportComment={reportComment}
              denialReason={denialReason}
              openCollectConfirmDialog={this.handleOpenConfirmDialog.bind(
                this,
                MessageTemplate.MSG_COLLECT_REPORT,
                null,
                ReportConstants.Label_Collect,
              )}
              openApprovalConfirmDialog={this.handleOpenConfirmDialog.bind(
                this,
                MessageTemplate.MSG_APPROVAL_REPORT,
                null,
                ReportConstants.Label_Approval,
              )}
              openFinishConfirmDialog={this.handleOpenConfirmDialog.bind(
                this,
                MessageTemplate.MSG_FINISH_REPORT,
                null,
                ReportConstants.Label_Finish,
              )}
              openSaveDialog={this.handleOpenConfirmDialog.bind(
                this,
                MessageTemplate.MSG_SAVE_REPORT,
                null,
                ReportConstants.Label_Save,
              )}
              openWithDrawalDialog={this.handleOpenConfirmDialog.bind(
                this,
                MessageTemplate.MSG_WITHDRAWAL_CONFIRM_REPORT,
                null,
                ReportConstants.Label_WithDrawal,
              )}
              openRemandInputDialog={this.handleOpenInputDialog.bind(
                this,
                MessageTemplate.MSG_REMAND_REPORT,
                ReportConstants.Name_Denial_Reason,
                denialReason,
                ReportConstants.Label_Remand,
                false,
              )}
              openReasonInputDialog={this.handleOpenInputDialog.bind(
                this,
                MessageTemplate.MSG_REASON_REPORT,
                ReportConstants.Name_Denial_Reason,
                denialReason,
                ReportConstants.Label_Reason,
                false,
              )}
              onEnableFinishSaveButton={this.handleEnableFinishSaveButton.bind(this, ReportConstants.Label_Correct)}
            />
        }
          <Form.Group>
            <Col sm={12} className={'margin-top-10'}>
              <Col sm={this.state.iframeQuestionCol}>
                <img
                  src={this.state.iframeQuestionCol === MAX_IFRAME_QUESTION_COL ? ZoomOut : ZoomIn}
                  onClick={() => {
                    this.state.iframeQuestionCol === MAX_IFRAME_QUESTION_COL ? this.zoomContent(false) : this.zoomContent(true);
                  }}
                  className="zoomInButton"
                />
                <div className="borderSolid0pxHalf iframe-question" id="iframe_wrapper">
                  <iframe
                    title="enforceHistoryIframe"
                    src={enforceHistoryUrl}
                    width="100%"
                  />
                </div>
              </Col>
              { this.state.scoringCol > 0 &&
                <Col sm={this.state.scoringCol} className="padding-left-clear">
                  <ScoringReportModalQuestion
                    {...this.props}
                    enableFinishSaveButton={enableFinishSaveButton}
                  />
                </Col>
              }
            </Col>
          </Form.Group>
        </ModalWrapper>
        <DialogConfirm
          showModal={this.state.showModalConfirm}
          onCancel={this.onConfirmDialogCancelBtnClick}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onConfirmDialogOkBtnClick}
        />
        <InformationDialog
          showModal={this.state.showInformationModal}
          content={this.content}
          onOK={this.onConfirmDialogOkBtnClick}
        />
        <InputInformationDialog
          showModal={this.state.showInputInformationModal}
          content={this.content}
          name={this.name}
          value={this.value}
          onOK={this.onConfirmDialogOkBtnClick}
        />
        <InputConfirmDialog
          showModal={this.state.showInputConfirmModal}
          content={this.content}
          name={this.name}
          value={this.value}
          disableInput={this.disableInput}
          onOK={this.props.handleSubmit(this.onInputConfirmDialogOkBtnClick)}
          onCancel={this.onConfirmDialogCancelBtnClick.bind(this, true)}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { sankakuMarkSet, modalReport, detailDrill, scoreForm, markRule, sankakuJudgeUseSet, questionListOutput } = {
    ...state.scoringReport,
  };
  const { reportModalDialog } = state.form;
  const { authedUser } = state.authed;
  const { questionInfo, partsQuestionInfo } = detailDrill;
  const data = {
    denialReason: modalReport.denialReason,
    reportComment: modalReport.reportComment,
    reportCommentDrillQuestion: detailDrill.reportCommentDrillQuestion,
    partsQuestionInfo,
    answerJudgeResult:
    questionInfo ? questionInfo.answerJudgeResult : ReportConstants.ANSWER_JUDGE_RESULT.BIG_QUESTION,
  };

  const isScoreFormScoreDisplay = scoreForm === ReportConstants.SCORE_FORM_SCORE;
  let isPartialPointUseSet = false;
  if (
    isScoreFormScoreDisplay &&
    markRule === ReportConstants.MARK_RULE_ABSOLUTE_SCORE &&
    sankakuJudgeUseSet === ReportConstants.SANKAKU_JUDGE_USE_SET_USE
  ) {
    isPartialPointUseSet = true;
  }

  if (partsQuestionInfo &&
    partsQuestionInfo.subQuestionArray &&
    partsQuestionInfo.subQuestionArray.length !== 0) {
    // case big question
    const { subQuestionArray } = partsQuestionInfo;
    for (let i = 0; i < subQuestionArray.length; i++) {
      const name = `subAnswerJudgeResult_${i}`;
      // #7404 START
      const subModifiedSankakuPointName = `subModifiedSankakuPoint_${i}`;
      delete modalReport.subModifiedSankakuPointName;
      const subQuestionInfo = subQuestionArray[i];
      let subAnswerJudgeResult = subQuestionInfo.subAnswerJudgeResult;
      const subPoint = subQuestionInfo.subPoint;
      // #7404 END
      if (
        subAnswerJudgeResult !== ReportConstants.ANSWER_JUDGE_RESULT.CORRECT &&
        subAnswerJudgeResult !== ReportConstants.ANSWER_JUDGE_RESULT.NOT_ANSWER
      ) {
        subAnswerJudgeResult = ReportConstants.ANSWER_JUDGE_RESULT.INCORRECT;
      }
      data[name] = subAnswerJudgeResult;
      // #7404 START
      let subModifiedSankakuPoint;
      if (subQuestionInfo.subModifiedSankakuPoint === null) {
        if (sankakuMarkSet && subPoint) {
          subModifiedSankakuPoint = parseInt((sankakuMarkSet / 100) * subPoint, 10);
        }
      } else {
        subModifiedSankakuPoint = subQuestionInfo.subModifiedSankakuPoint;
      }
      if (isPartialPointUseSet) {
        data[subModifiedSankakuPointName] = subModifiedSankakuPoint;
      }
      // #7404 END
    }
  } else if (questionInfo) {
    delete modalReport.modifiedSankakuPoint;
    // case single question
    let answerJudgeResultTemp = data.answerJudgeResult;
    answerJudgeResultTemp = parseInt(answerJudgeResultTemp, 10);
    // in case single question, if answerJudgeResult != 0 and 2 => set answerJudgeResult = 1
    if (answerJudgeResultTemp !== ReportConstants.ANSWER_JUDGE_RESULT.CORRECT &&
      answerJudgeResultTemp !== ReportConstants.ANSWER_JUDGE_RESULT.NOT_ANSWER) {
      data.answerJudgeResult = ReportConstants.ANSWER_JUDGE_RESULT.INCORRECT;
    }

    // #7404 START
    const nameModifiedSankakuPoint = 'modifiedSankakuPoint';
    const namePoint = 'point';
    let modifiedSankakuPoint;
    if (questionInfo.modifiedSankakuPoint === null) {
      if (sankakuMarkSet && questionInfo.point) {
        modifiedSankakuPoint = parseInt((sankakuMarkSet / 100) * questionInfo.point, 10);
      }
    } else {
      modifiedSankakuPoint = questionInfo.modifiedSankakuPoint;
    }
    if (isPartialPointUseSet) {
      data[nameModifiedSankakuPoint] = modifiedSankakuPoint;
    }
    data[namePoint] = questionInfo.point;
  }

  // Get drill_secern_id
  let drillSecernId;
  if (detailDrill && Object.keys(detailDrill).length > 0) {
    const { enforceHistoryUrl } = detailDrill;
    const drillElement = enforceHistoryUrl.split('&').filter((e) => e.indexOf('drill_secern_id') > -1)[0];
    const drillElementArr = drillElement.split('=');
    if (drillElementArr.length === 2) {
      drillSecernId = drillElementArr[1];
    }
  }

  // #7404 END

  return {
    ...{ authedUser },
    ...{ modalReport },
    ...{ reportModalDialog },
    ...{ detailDrill },
    ...{ drillSecernId },
    ...{ sankakuMarkSet },
    ...{ questionListOutput },
    ...{ isScoreFormScoreDisplay },
    ...{ isPartialPointUseSet },
    ...{ sankakuJudgeUseSet },
    initialValues: { ...data },
    formValues: getFormValues('reportModalDialog')(state),
    invalid: isInvalid('reportModalDialog')(state),
    pristine: isPristine('reportModalDialog')(state),
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'reportModalDialog',
    enableReinitialize: true,
  })(ReportModalDialogContainer),
);
